export const MultiUnitOptions = [
  'unit',
  '#',
  'apt',
  'bsmt',
  'bldg',
  'fl',
  'frnt',
  'lowr',
  'ph',
  'pier',
  'rear',
  'rm',
  'side',
  'slip',
  'trlr',
  'uppr',
];

export const CheckWordInString = (searchString, word) =>
  new RegExp(`\\b${word}\\b`, 'i').test(searchString);

export const FetchSubUnits = searchString =>
  MultiUnitOptions.filter(word => CheckWordInString(searchString, word));

export const FormatAddress = ({ address, moreEntries }) => {
  if (moreEntries) {
    return `${address?.streetLine} ${address?.secondary?.toUpperCase()} (${
      address?.entries
    }) ${address?.city}, ${address?.state}, ${address?.zipcode}`;
  }
  if (address?.secondary) {
    // child building address list Eg. APT
    const formattedAddress = `${
      address?.streetLine
    } ${address?.secondary?.toUpperCase()}, ${address?.city}, ${
      address?.state
    }, ${address?.zipcode}`;
    if (address?.entries > 1) {
      return `${formattedAddress} (${address?.entries} more entries)`;
    }
    return formattedAddress;
  }
  // parent building address
  return `${address?.streetLine}, ${address?.city}, ${address?.state}, ${address?.zipcode}`;
};
